import {
  LOAD_PLAN_CATALOG,
  STORE_PLAN_CATALOG,
  PLAN_CATALOG_LOADING,
  PUBLISH_PLAN_CATALOG,
  PREVIEW_PLAN_CATALOG,
  STORE_PLAN_CATALOG_PREVIEW,
  APPLY_PENDING_PLAN_CATALOG,
  SET_COMPANY_CUSTOM_RATE,
} from '../../constants/planCatalog';

export const loadPlanCatalog = (data) => ({ type: LOAD_PLAN_CATALOG, data });

export const storePlanCatalog = (overview) => ({
  type: STORE_PLAN_CATALOG,
  overview,
});

export const setPlanCatalogLoading = (loading) => ({
  type: PLAN_CATALOG_LOADING,
  loading,
});

export const previewPlanCatalog = (data, callback) => ({
  type: PREVIEW_PLAN_CATALOG,
  data,
  callback,
});

export const storePlanCatalogPreview = (preview) => ({
  type: STORE_PLAN_CATALOG_PREVIEW,
  preview,
});

export const publishPlanCatalog = (data, callback) => ({
  type: PUBLISH_PLAN_CATALOG,
  data,
  callback,
});

export const applyPendingPlanCatalog = (data, callback) => ({
  type: APPLY_PENDING_PLAN_CATALOG,
  data,
  callback,
});

export const setCompanyCustomRate = (data, callback) => ({
  type: SET_COMPANY_CUSTOM_RATE,
  data,
  callback,
});
